module.exports = __webpack_public_path__ + "img/yexiao.746a5b72.png";